export default __webpack_public_path__ + "static/media/BackArrow.03545640.svg";